import React from 'react';
import './Header.css'; // スタイルシートをインポート
import { scrollToMonthGrid } from '../../utils/scrollUtils';

function Header({ hideMobileCta = false }) {
  return (
    <header className="flex header">
      <button
        className={`link-button${hideMobileCta ? ' is-hidden-mobile' : ''}`}
        onClick={scrollToMonthGrid}
      >
        つくる
      </button>
    </header>
  );
}

export default Header;
